/* okca-notes.js — notas clave, duración e iconos de línea para la compra asistida.
   API: OKCA.notes.key(p) · top2(p) · duration(p) · icon(name, size)
   Sólo lee s, c, f e int de cada perfume. ES5, sin dependencias. */
(function (w) {
  'use strict';
  w.OKCA = w.OKCA || {};

  var LABELS_ES = { s: 'Al ponértelo', c: 'A la hora', f: 'Lo que queda' };
  function label(k) { var t = window.OKCA_T || {}; return t['n_' + k] || LABELS_ES[k]; }
  var MAXLEN = 16;

  /* ---------- Utilidades de texto ---------- */
  function norm(s) { // minúsculas y sin acentos
    return String(s || '').toLowerCase()
      .replace(/[áàä]/g, 'a').replace(/[éèë]/g, 'e').replace(/[íìï]/g, 'i')
      .replace(/[óòö]/g, 'o').replace(/[úùü]/g, 'u').replace(/ñ/g, 'n');
  }

  // Lugares y gentilicios que se descartan («bergamota de Calabria» → «Bergamota»)
  var PLACES = 'calabria|sicilia|amalfi|virginia|madagascar|tunez|bulgaria|damasco|turquia|haiti|tahiti|java|indonesia|mysore|india|egipto|marruecos|espana|italia|francia|grasse|brasil|ceilan|texas|atlas|himalaya|jamaica|cuba|mexico|guatemala|china|japon|sri lanka|oriente|oriente medio|persia|siria|iran|sudafrica|reunion|comores|zanzibar|vietnam|laos|camboya|tailandia|yemen|oman|somalia|etiopia|canada|siberia|provenza|toscana|florencia|verbena';
  var PLACE_RE = new RegExp('\\s+(de|del|de la|de los|d\')\\s*(' + PLACES + ')$', 'i');
  var ADJ_RE = /\s+(nigerian[oa]s?|italian[oa]s?|indi[oa]s?|hindu|espanol(a|es)?|egipci[oa]s?|turc[oa]s?|bulgar[oa]s?|haitian[oa]s?|tahitian[oa]s?|sicilian[oa]s?|calabres(a)?|indonesi[oa]s?|marroqui(es)?|brasilen[oa]s?|frances(a)?|african[oa]s?|chin[oa]s?|jamaican[oa]s?|mexican[oa]s?|bourbon)$/i;

  var ALIAS = { 'leche de almendras': 'Almendra', 'leche de coco': 'Coco', 'lirio de los valles': 'Lirio del valle', 'flor de naranjo': 'Flor de naranjo' };

  function clean(raw) {
    var t = String(raw || '').replace(/\([^)]*\)/g, ' ').replace(/[.;:]+$/g, '').replace(/\s+/g, ' ').trim();
    if (!t) return '';
    var low = t.toLowerCase();
    if (ALIAS[norm(low)]) return ALIAS[norm(low)];
    // dos pasadas por si hay lugar + gentilicio
    var i, prev;
    for (i = 0; i < 2; i++) {
      prev = low;
      low = low.replace(PLACE_RE, '');
      // el regex trabaja sobre texto sin acentos; probamos también sobre la versión normalizada
      if (norm(low) !== low) {
        var n2 = norm(low), n3 = n2.replace(PLACE_RE, '').replace(ADJ_RE, '');
        if (n3 !== n2) low = low.slice(0, n3.length);
      }
      low = low.replace(ADJ_RE, '');
      if (low === prev) break;
    }
    low = low.replace(/^madera de\s+(?=\S)/, '').replace(/^maderas de\s+(?=\S)/, '').trim();
    if (norm(low) === 'madera de gaiac') low = 'gaiac';
    if (low.length > MAXLEN) { // recorta por palabra
      var cut = low.indexOf(' de ');
      if (cut > 3) low = low.slice(0, cut);
      while (low.length > MAXLEN && low.indexOf(' ') > 0) low = low.slice(0, low.lastIndexOf(' '));
      if (low.length > MAXLEN) low = low.slice(0, MAXLEN);
    }
    return low.charAt(0).toUpperCase() + low.slice(1);
  }

  /* ---------- Iconos (trazo 24x24, mismo estilo de línea que okp-olf-glyph) ---------- */
  var G = {
    citrus: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="6"/><path d="M12 4v16M5.1 8l13.8 8M5.1 16l13.8-8" stroke-width="1.2"/>',
    leaf: '<path d="M5 19C5 10.5 10 5 19 5c0 9-5.5 14-14 14z"/><path d="M5 19l8-8"/>',
    lavender: '<path d="M12 21V10"/><path d="M12 10C10.4 8.8 10.4 6.5 12 4c1.6 2.5 1.6 4.8 0 6z"/><path d="M12 15c-2.5-.2-3.8-1.6-4-3.5 2.5.2 3.8 1.6 4 3.5zM12 15c2.5-.2 3.8-1.6 4-3.5-2.5.2-3.8 1.6-4 3.5z"/>',
    marine: '<path d="M3 9c3-3 6 3 9 0s6 3 9 0M3 15c3-3 6 3 9 0s6 3 9 0"/>',
    fruit: '<path d="M12 8c-2-1.5-7-1-7 5 0 4 3 8 5 8 1 0 1.2-.5 2-.5s1 .5 2 .5c2 0 5-4 5-8 0-6-5-6.5-7-5z"/><path d="M12 8c0-2 1-3.5 3-4.5"/>',
    berry: '<circle cx="8" cy="16" r="4"/><circle cx="16.5" cy="17" r="3.5"/><path d="M8 12c0-4 3-7 9-8M16.5 13.5c0-4 .3-7 .5-9.5"/><path d="M17 4c2 0 3.5 1 4 2.5-2 .5-3.5 0-4-2.5z"/>',
    tropical: '<path d="M12 11c-3.5 0-5 3-5 6.5S9 22 12 22s5-1 5-4.5-1.5-6.5-5-6.5z"/><path d="M12 11V6M12 11L8.5 6.5M12 11l3.5-4.5M9 15l6 5M15 15l-6 5"/>',
    rose: '<path d="M6 6.5c0 4.5 2.5 7 6 7s6-2.5 6-7c-2 1.2-4 .8-6-1.5-2 2.3-4 2.7-6 1.5z"/><path d="M12 13.5V21M12 18c-2.5 0-4-1-4.5-2.5 2.5-.3 4 .5 4.5 2.5z"/><path d="M9.5 8.5c1 1.5 4 1.5 5 0"/>',
    flower: '<ellipse cx="12" cy="6.8" rx="2.6" ry="3.8"/><ellipse cx="12" cy="6.8" rx="2.6" ry="3.8" transform="rotate(72 12 12)"/><ellipse cx="12" cy="6.8" rx="2.6" ry="3.8" transform="rotate(144 12 12)"/><ellipse cx="12" cy="6.8" rx="2.6" ry="3.8" transform="rotate(216 12 12)"/><ellipse cx="12" cy="6.8" rx="2.6" ry="3.8" transform="rotate(288 12 12)"/>',
    iris: '<path d="M12 21v-8"/><path d="M12 13c-2.5-2-2.5-6 0-9 2.5 3 2.5 7 0 9z"/><path d="M12 14c-3-.5-5.5-3-6-6.5 3 .5 5.5 2.5 6 6.5zM12 14c3-.5 5.5-3 6-6.5-3 .5-5.5 2.5-6 6.5z"/>',
    spice: '<path d="M12 3.5l2.6 5.6 6 .8-4.4 4.2 1.1 6-5.3-2.9-5.3 2.9 1.1-6-4.4-4.2 6-.8z"/><circle cx="12" cy="12.5" r="1.5"/>',
    pepper: '<circle cx="8" cy="15.5" r="3.5"/><circle cx="16.5" cy="15" r="3.5"/><circle cx="12.2" cy="7.5" r="3.5"/><path d="M8 15.5h.01M16.5 15h.01M12.2 7.5h.01"/>',
    vanilla: '<path d="M4 20C9 16.5 15 10 19.5 4c.8 2.5.2 4.5-1.5 6.5C14.5 14.5 9.5 19 5.5 21z"/><path d="M7 17.5l2.5 2"/>',
    sweet: '<path d="M12 3.5c-4 0-6.5 4-6.5 8.5s2.5 8.5 6.5 8.5 6.5-4 6.5-8.5S16 3.5 12 3.5z"/><path d="M12 4c-3 3.5 3 5.5 0 8s3 4.5 0 8"/>',
    nut: '<path d="M12 3.5c4 3.5 6 7 6 10.5a6 6 0 0 1-12 0C6 10.5 8 7 12 3.5z"/><path d="M12 8v12"/>',
    amber: '<path d="M8 4h8l5 6-9 11-9-11z"/><path d="M3 10h18M8 4l4 6 4-6M12 10v11"/>',
    wood: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="5"/><path d="M12 12h.01M9 12a3 3 0 0 1 3-3"/>',
    moss: '<path d="M5 19c0-4 1-7 2-9 1 2 2 5 2 9M10 19c0-5 1-9 2.5-12 1.5 3 2.5 7 2.5 12M16 19c0-3 .5-5 1.5-7 1 2 1.5 4 1.5 7M3.5 19.5h17"/>',
    leather: '<rect x="3.5" y="6" width="17" height="12" rx="2"/><rect x="6.5" y="9" width="11" height="6" rx="1" stroke-dasharray="2 2"/>',
    musk: '<circle cx="12" cy="12" r="2.5"/><circle cx="12" cy="12" r="6" stroke-dasharray="2.5 2.5"/><circle cx="12" cy="12" r="9.5" stroke-dasharray="1 3.5"/>',
    oud: '<path d="M6 20.5L3.5 9.5l6-5.5 8 3 3 9-5.5 5z"/><path d="M8 9.5l7 3M9 14.5l6 3"/>',
    smoke: '<path d="M8 21c-2.5-3 2-5 0-8s2-5 0-8M15 20c-2-2.5 1.5-4 0-6.5s1.5-4 0-6.5"/>',
    drop: '<path d="M12 3.5c3.5 4.5 6 7.5 6 11a6 6 0 0 1-12 0c0-3.5 2.5-6.5 6-11z"/>'
  };

  // Reglas por orden: lo compuesto antes que lo genérico. Texto sin acentos; las
  // claves se comparan por inicio de palabra y, si acaban en espacio, por palabra entera.
  var RULES = [
    ['oud', ['oud', 'agar ', 'agarwood', 'madera de oud']],
    ['smoke', ['humo', 'ahumad', 'alquitran', 'brea ', 'madera quemada', 'carbon']],
    ['moss', ['musgo', 'pachuli', 'oakmoss', 'liquen']],
    ['pepper', ['pimienta']],
    ['flower', ['flor de naranjo', 'flor del naranjo', 'azahar', 'jazmin', 'tuberosa', 'nardo', 'gardenia', 'azucena', 'magnolia', 'ylang', 'lirio de los valles', 'muguet', 'fresia', 'jacinto', 'narciso', 'orquidea', 'mimosa', 'flor de loto', 'loto', 'flor blanca', 'flores blancas', 'flor de tiare', 'tiare', 'osmanto', 'camelia', 'lirio', 'madreselva', 'frangipani', 'ciclamen', 'nenufar', 'jamin', 'hediona', 'hedione']],
    ['wood', ['palo de rosa', 'madera', 'amadera', 'cedro', 'sandalo', 'vetiver', 'gaiac', 'guayaco', 'abedul', 'cipres', 'roble', 'amberwood', 'akigalawood', 'iso e super', 'enebro', 'pino', 'teca', 'bambu', 'palisandro', 'sequoia', 'abeto', 'caoba', 'palo santo', 'olivo']],
    ['amber', ['ambar', 'ambrox', 'incienso', 'olibano', 'mirra', 'ladano', 'labdano', 'benjui', 'elemi', 'resina', 'styrax', 'estoraque', 'opopon', 'galbano', 'amber', 'castoreo', 'copal', 'balsamo', 'oriental']],
    ['vanilla', ['vainilla', 'tonka']],
    ['spice', ['canela', 'clavo', 'nuez moscada', 'cardamomo', 'azafran', 'jengibre', 'anis', 'comino', 'cilantro', 'alcaravea', 'especia', 'curcuma', 'casia', 'badiana', 'cascarilla']],
    ['nut', ['almendra', 'avellana', 'castana', 'nuez', 'pistacho', 'cacahuete', 'pecana', 'sesamo', 'frutos secos']],
    ['sweet', ['caramelo', 'praline', 'miel', 'chocolate', 'cacao', 'cafe', 'azucar', 'ron ', 'whisky', 'coñac', 'conac', 'brandy', 'toffee', 'turron', 'nata', 'crema', 'dulce', 'galleta', 'algodon', 'regaliz', 'malvavisco', 'merengue', 'moca ', 'palomitas', 'datiles', 'licor', 'ginebra', 'absenta', 'leche', 'cumarina']],
    ['rose', ['rosa', 'peonia', 'geranio', 'clavel', 'rosal']],
    ['iris', ['iris', 'violeta', 'polvo', 'empolvad', 'heliotropo', 'raiz de lirio', 'atalcad', 'lila ', 'mimosa']],
    ['lavender', ['lavanda', 'lavandin', 'esclarea', 'espliego']],
    ['leather', ['cuero', 'tabaco', 'gamuza', 'piel ', 'badana']],
    ['leaf', ['menta', 'hojas', 'hoja ', 'verde', 'te ', 'albahaca', 'salvia', 'romero', 'laurel', 'tomillo', 'hierba', 'mirto', 'cesped', 'eucalipto', 'helecho', 'hinojo', 'estragon', 'manzanilla', 'yerba mate', 'artemisa', 'valeriana', 'apio', 'rucula', 'bergamota de hoja']],
    ['marine', ['marin', 'acuos', 'acuatic', 'sal ', 'agua ', 'ozon', 'brisa', 'lluvia', 'oceano', 'mar ', 'algas', 'calone']],
    ['tropical', ['pina', 'mango', 'coco', 'maracuya', 'papaya', 'guayaba', 'platano', 'banana', 'tropical', 'fruta de la pasion']],
    ['citrus', ['limon', 'lima ', 'limas', 'bergamota', 'pomelo', 'mandarina', 'naranja', 'cidra', 'yuzu', 'neroli', 'citric', 'cedrat', 'petitgrain', 'kumquat', 'toronja', 'clementina', 'tangerina', 'agrios']],
    ['berry', ['grosella', 'frambuesa', 'frutos rojos', 'cereza', 'fresa', 'zarzamora', 'arandano', 'mora ', 'moras', 'bayas', 'baya ', 'frutos del bosque', 'cassis']],
    ['fruit', ['manzana', 'pera', 'melocoton', 'ciruela', 'albaricoque', 'higo', 'melon', 'uva', 'fruta', 'afrutad', 'membrillo', 'sandia', 'granada', 'durazno', 'lichi', 'mirabel', 'nectarina', 'kiwi']],
    ['musk', ['almizcl', 'ambreta', 'cachemira', 'cashmeran', 'musk', 'algalia', 'civet']]
  ];

  function family(name) {
    var n = ' ' + norm(name) + ' ';
    var i, j, k;
    for (i = 0; i < RULES.length; i++) {
      for (j = 0; j < RULES[i][1].length; j++) {
        k = norm(RULES[i][1][j]);
        if (n.indexOf(' ' + k) !== -1) {
          // claves terminadas en espacio: palabra entera
          if (k.charAt(k.length - 1) === ' ' && n.indexOf(' ' + k) === -1) continue;
          return RULES[i][0];
        }
      }
    }
    return 'drop';
  }

  function icon(name, size) {
    var fam = G[name] ? name : family(name);
    var s = size > 0 ? size : 18;
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="' + s + '" height="' + s +
      '" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      (G[fam] || G.drop) + '</svg>';
  }

  /* ---------- Elección de notas ---------- */
  // Notas vagas: sólo valen si no hay nada concreto en la capa
  var VAGUE_RE = /^(notas?\b|aldehid|ambrox|iso e super|akigalawood|amberwood|cashmeran|especias?$|citricos?$|frutas?$|flores?$|maderas?$|resinas?$|balsamicos?$|acordes?\b|acuerdo)/;
  // Muy reconocibles (nivel A)
  var STRONG_RE = /(limon|bergamota|pomelo|mandarina|naranja|lavanda|menta|manzana|pina|melocoton|pera\b|rosa\b|jazmin|vainilla|canela|cafe|coco|cacao|caramelo|miel|sandalo|cedro|cuero|tabaco|oud|incienso|tonka|azahar|violeta|iris|jengibre|cardamomo|pimienta|grosella|frambuesa|higo|vetiver|mango|fresa|cereza|almendra|lima\b|neroli|lirio|peonia|geranio|salvia|albahaca|romero|ron\b)/;
  // Bases comunes (nivel B): válidas pero menos «visuales»
  var STAPLE_RE = /(almizcl|ambar|pachuli|ladano|benjui|musgo|mirra|olibano|ambreta|cachemira|elemi|styrax)/;

  function tokens(str) {
    var out = [], parts = String(str || '').split(/,|;| y (?=[a-záéíóúñ])/i), i, nm;
    for (i = 0; i < parts.length; i++) {
      nm = clean(parts[i]);
      if (nm) out.push(nm);
    }
    return out;
  }

  function score(name, pos, usedNames, usedFams) {
    var n = norm(name), fam = family(name), sc = pos * 0.5;
    if (VAGUE_RE.test(n)) sc += 100;
    else if (STRONG_RE.test(n)) sc += 0;
    else if (STAPLE_RE.test(n)) sc += 4;
    else if (fam !== 'drop') sc += 8;
    else sc += 14;
    if (name.length > MAXLEN) sc += 5;
    if (usedFams[fam] && fam !== 'drop') sc += 3;
    if (usedNames[n]) sc += 1000;
    return sc;
  }

  function pick(list, usedNames, usedFams) {
    var best = null, bs = 1e9, i, sc;
    for (i = 0; i < list.length; i++) {
      sc = score(list[i], i, usedNames, usedFams);
      if (sc < bs) { bs = sc; best = list[i]; }
    }
    return bs >= 1000 ? null : best;
  }

  function key(p) {
    var out = [], used = {}, fams = {}, parts = ['s', 'c', 'f'], i, nm, fam;
    if (!p) return out;
    for (i = 0; i < parts.length; i++) {
      nm = pick(tokens(p[parts[i]]), used, fams);
      if (!nm) continue;
      used[norm(nm)] = 1;
      fam = family(nm);
      fams[fam] = 1;
      out.push({ part: parts[i], label: label(parts[i]), name: nm, icon: icon(fam, 18) });
    }
    return out;
  }

  function top2(p) {
    var used = {}, fams = {}, res = [], a, b, c;
    if (!p) return res;
    a = pick(tokens(p.s), used, fams);
    if (a) { used[norm(a)] = 1; fams[family(a)] = 1; res.push(a); }
    b = pick(tokens(p.f), used, fams);
    if (b) { used[norm(b)] = 1; fams[family(b)] = 1; res.push(b); }
    if (res.length < 2) { // completa con el corazón
      c = pick(tokens(p.c), used, fams);
      if (c) res.push(c);
    }
    return res;
  }

  function duration(p) {
    var v = p && p.int, i, t;
    if (!v) return '';
    if (Object.prototype.toString.call(v) !== '[object Array]') v = [v];
    for (i = 0; i < v.length; i++) {
      t = norm(v[i]).trim();
      if (t === 'muy fuerte') return '10–12 h';
      if (t === 'fuerte') return '8–10 h';
      if (t === 'media') return '6–8 h';
      if (t === 'suave') return '4–6 h';
    }
    return '';
  }

  w.OKCA.notes = { key: key, top2: top2, duration: duration, icon: icon };
  w.OKCA.notes._family = family; // útil para depurar
  w.OKCA.notes._icons = G;
})(window);
